"use strict";

exports.__esModule = true;
exports.default = nonHtmlPropsHaveChanged;
function nonHtmlPropsHaveChanged(props, prevProps) {
  return Object.keys(props).some(function (key) {
    return !Object.hasOwn(props, key) && props[key] !== prevProps[key];
  });
}